import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link, useLocation } from 'react-router-dom';
import logoSeal from '../../assets/images/logoSeal.png';
import logo from '../../assets/images/TheUSWillRegistry-slogan.png';
import TheNavigation from './TheNavigation';
import { isMobile } from 'react-device-detect';

const TheHeader = ({ userState, username, slug }) => {
  const pathname = useLocation().pathname.toLowerCase();
  const token = localStorage.getItem('attorney_registration_token');
  const isLoginPath =
    pathname.includes('login') || pathname.includes('find-an-attorney');

  return (
    <header>
      <Navbar expand="lg" className="mobile-header-top">
        <Container>
          <div className="mobile-header-wrp">
            <div className="brand-box">
              <Link to="/">
                <img
                  src={logo}
                  className="logo-slogan"
                  alt="The U.S. Will Registry Logo"
                  width={isMobile ? 206 : 310}
                  height={isMobile ? 40 : 60}
                />
              </Link>
            </div>
            <div className="right-logo">
              <Link to="/">
                <img
                  className="img-fluids"
                  src={logoSeal}
                  alt="The U.S. Will Registry Seal"
                  width={isMobile ? 90 : 140}
                  height={isMobile ? 90 : 140}
                />
              </Link>
            </div>
          </div>
        </Container>
      </Navbar>
      <Navbar expand="lg" className="navbar-main">
        <Container>
          <div className="d-flex align-items-center flex-wrap justify-content-between top-navbar py-1">
            <Navbar.Brand href="/">
              <img src={logo} className="logo-slogan" alt="Slogan" />
            </Navbar.Brand>
            {token && (
              <Dropdown className="user-menu">
                <Dropdown.Toggle as="div" className="menu-button">
                  <span>{username}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Header>Access Your Account</Dropdown.Header>
                  <div className="menu-items">
                    {userState?.user?.password_changed &&
                    userState?.user?.subscription !== null &&
                    userState?.user?.is_profile_complete ? (
                      <>
                        <Dropdown.Item as={Link} to="/account-details">
                          Account Details
                        </Dropdown.Item>
                        <Dropdown.Item
                          as={Link}
                          to={`/attorney-directory/${slug}`}
                          state={{
                            from: '/account-details',
                          }}
                        >
                          View Profile
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/profile">
                          Edit Profile
                        </Dropdown.Item>
                      </>
                    ) : (
                      <Dropdown.Item as={Link} to="/complete-profile">
                        Complete Profile
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item as={Link} to="/logout">
                      Logout
                    </Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {!token && !isLoginPath && (
              <Nav.Item className="d-flex align-items-center nav-list">
                <Nav.Link
                  as={Link}
                  to="/login"
                  eventKey="1"
                  className="login-btn"
                >
                  Login
                </Nav.Link>
              </Nav.Item>
            )}
          </div>
        </Container>
      </Navbar>
      <TheNavigation userState={userState} username={username} slug={slug} />
    </header>
  );
};

export default TheHeader;
